import { NEW_PATH_DELIMITER } from '@picsio/db/src/constants';
import getGroups from './getGroups';

/**
 * Resolves where an undone saved-search delete should be recreated.
 *
 * `desiredParentPath` comes from the deleted item's full path with the leaf
 * segment removed. If that group (or an ancestor) was removed afterward — e.g.
 * cascade when a parent group was deleted — the API must not receive a stale
 * parent path. We only return a path that still appears in the current scope's
 * group set (same rules as {@link getGroups}); otherwise we walk up to the
 * deepest still-existing ancestor, or `undefined` for scope root.
 */
export default function resolveParentPathForUndoRestore(all, isShared, desiredParentPath) {
  const segs = (desiredParentPath || '').split(NEW_PATH_DELIMITER).filter(Boolean);
  if (!segs.length) return undefined;
  const { team, personal } = getGroups(all);
  const valid = new Set(isShared ? team : personal);
  for (let n = segs.length; n >= 1; n -= 1) {
    const candidate = `${NEW_PATH_DELIMITER}${segs.slice(0, n).join(NEW_PATH_DELIMITER)}`;
    if (valid.has(candidate)) return candidate;
  }
  return undefined;
}
